import { app } from '../../../../app';

app.service('AddProfileModal', modal);

/** @ngInject */
function modal($uibModal) {

    return () => {
        return $uibModal.open({
            component: 'addProfile',
            resolve: {activeEmails}
        }).result;
    }
}

/** @ngInject */
function activeEmails(UserEmailsService) {
    return UserEmailsService.getActiveEmails().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/add/add.modal.js